module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Regensberg-ea2fe0794f4e61c86a32c785f79b3695.svg";